import React from 'react';
import { s as styles } from './viewer-inline-toolbar.rtlignore-7108529d.js';
import twitter from './icons/twitter.js';

function openTwitter(selectedText) {
  let text = "\u201C" + selectedText + "\u201C\u2014";
  const url = window.location.href;
  const maxTweetLength = 279;
  if (text.length + url.length > maxTweetLength) {
    const maxTextLength = maxTweetLength - url.length;
    text = handleText(text, maxTextLength);
  }
  const TWEET_ON_TWITTER_URL = `https://twitter.com/intent/tweet?text=${encodeURI(
    text
  )}&url=${encodeURI(url)}`;
  window.open(TWEET_ON_TWITTER_URL);
}
function handleText(text, maxTextLength) {
  let content = text.substring(0, maxTextLength - 2);
  content = content.slice(0, content.lastIndexOf(" "));
  content += "\u2026\u201C\u2014";
  return content;
}
const TwitterButton = ({ selectedText, onClick }) => {
  const handleOnClick = (selectedText2) => {
    onClick == null ? void 0 : onClick(selectedText2);
    openTwitter(selectedText2);
  };
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      "data-hook": "twitter-button",
      className: styles.button,
      onClick: () => handleOnClick(selectedText),
      type: "button"
    },
    /* @__PURE__ */ React.createElement(twitter, null)
  );
};

export { TwitterButton as default };
//# sourceMappingURL=TwitterButton.js.map
